import {snakeCase} from 'lodash';
import {MxHTMLAttribute} from '../models/mx-html-attribute.interface';

export function createTrackHtmlAttribute(value: string | string[]): MxHTMLAttribute {
  return {name: 'q9track', value: snakeCase(Array.isArray(value) ? value.join('.') : value)};
}
